import { render, staticRenderFns } from "./ArcTabV2.vue?vue&type=template&id=6bf69878&scoped=true&"
import script from "./ArcTabV2.vue?vue&type=script&lang=js&"
export * from "./ArcTabV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf69878",
  null
  
)

export default component.exports